import { Typography } from '@mui/material'
import { MarkerContainer } from './styles'

type ClusterMarkerProps = {
  locationCount: number
  onClick: () => void
}

const ClusterMarker = ({
  locationCount,
  onClick,
}: ClusterMarkerProps): JSX.Element => (
  <MarkerContainer onClick={onClick}>
    <div>
      <Typography>{locationCount}</Typography>
    </div>
  </MarkerContainer>
)

export default ClusterMarker
